(function () {
  const PAGE_PATH = '/collections/specialty-pulls';
  const SECTION_SELECTOR = '#shopify-section-template--21387133616283__image_with_text_LFywyi';

  const MORE_TEXT = 'View more';
  const LESS_TEXT = 'Show less';

  if (window.location.pathname !== PAGE_PATH) return;

  function injectStyle() {
    if (document.getElementById('cfs-readmore-style')) return;

    const style = document.createElement('style');
    style.id = 'cfs-readmore-style';
    style.textContent = `
      .cfs-readmore-panel {
        position: relative;
        justify-content: flex-start !important;
        overflow: hidden !important;
        transition: height .35s ease, max-height .35s ease;
      }

      .cfs-readmore-panel.cfs-is-collapsed::after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 150px;
        z-index: 1;
        pointer-events: none;
        border-radius: inherit;
        background: linear-gradient(
          to bottom,
          rgba(96, 128, 80, 0),
          var(--cfs-panel-bg, rgb(99, 132, 80)) 72%
        );
      }

      .cfs-readmore-panel .image-with-text__text {
        transition: max-height .35s ease;
      }

      .cfs-readmore-panel.cfs-is-collapsed .image-with-text__text {
        overflow: hidden !important;
      }

      .cfs-readmore-btn {
        position: absolute;
        left: 70px;
        bottom: 34px;
        z-index: 2;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        min-height: 42px;
        padding: 0 20px;
        border: 1px solid rgba(255, 255, 255, .78);
        border-radius: 999px;
        background: rgba(255, 255, 255, .92);
        color: var(--cfs-panel-bg, rgb(99, 132, 80));
        box-shadow: 0 10px 26px rgba(0, 0, 0, .16);
        font: inherit;
        font-size: 14px;
        font-weight: 700;
        line-height: 1;
        cursor: pointer;
        backdrop-filter: blur(10px);
        transition: transform .2s ease, background .2s ease, box-shadow .2s ease;
      }

      .cfs-readmore-btn::after {
        content: "";
        width: 7px;
        height: 7px;
        border-right: 2px solid currentColor;
        border-bottom: 2px solid currentColor;
        transform: rotate(45deg) translateY(-2px);
        transition: transform .2s ease;
      }

      .cfs-readmore-panel.cfs-is-expanded .cfs-readmore-btn::after {
        transform: rotate(225deg) translateY(-1px);
      }

      .cfs-readmore-btn:hover {
        background: #fff;
        transform: translateY(-1px);
        box-shadow: 0 14px 32px rgba(0, 0, 0, .2);
      }

      @media screen and (max-width: 749px) {
        .cfs-readmore-btn {
          left: 24px;
          bottom: 24px;
          min-height: 40px;
          padding: 0 18px;
          font-size: 13px;
        }

        .cfs-readmore-panel.cfs-is-collapsed::after {
          height: 130px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function setupReadMore() {
    injectStyle();

    const section = document.querySelector(SECTION_SELECTOR);
    if (!section) return;

    const media = section.querySelector('.image-with-text__media');
    const content = section.querySelector('.image-with-text__content');
    const text = section.querySelector('.image-with-text__text');
    const heading = section.querySelector('.image-with-text__heading');

    if (!media || !content || !text) return;

    const panelBg = window.getComputedStyle(content).backgroundColor;
    if (panelBg) content.style.setProperty('--cfs-panel-bg', panelBg);

    content.classList.add('cfs-readmore-panel');

    let button = content.querySelector('.cfs-readmore-btn');
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'cfs-readmore-btn';
      button.textContent = MORE_TEXT;
      content.appendChild(button);
    }

    function getOuterHeight(el) {
      if (!el) return 0;
      const rect = el.getBoundingClientRect();
      const style = window.getComputedStyle(el);
      return rect.height + parseFloat(style.marginTop || 0) + parseFloat(style.marginBottom || 0);
    }

    function collapse() {
      const imageHeight = Math.round(media.getBoundingClientRect().height);
      if (!imageHeight) return;

      const contentStyle = window.getComputedStyle(content);
      const paddingTop = parseFloat(contentStyle.paddingTop || 0);
      const paddingBottom = parseFloat(contentStyle.paddingBottom || 0);
      const headingHeight = getOuterHeight(heading);
      const buttonSpace = 92;

      const textMaxHeight = Math.max(
        120,
        imageHeight - paddingTop - paddingBottom - headingHeight - buttonSpace
      );

      content.classList.add('cfs-is-collapsed');
      content.classList.remove('cfs-is-expanded');
      content.dataset.expanded = 'false';

      content.style.height = imageHeight + 'px';
      content.style.maxHeight = imageHeight + 'px';

      text.style.maxHeight = textMaxHeight + 'px';
      text.style.overflow = 'hidden';

      button.textContent = MORE_TEXT;
      button.hidden = text.scrollHeight <= textMaxHeight + 8;
    }

    function expand() {
      content.classList.remove('cfs-is-collapsed');
      content.classList.add('cfs-is-expanded');
      content.dataset.expanded = 'true';

      content.style.height = 'auto';
      content.style.maxHeight = 'none';

      text.style.maxHeight = 'none';
      text.style.overflow = 'visible';

      button.textContent = LESS_TEXT;
      button.hidden = false;
    }

    button.onclick = function () {
      if (content.dataset.expanded === 'true') {
        collapse();
      } else {
        expand();
      }
    };

    collapse();

    window.addEventListener('resize', function () {
      if (content.dataset.expanded !== 'true') collapse();
    });

    const img = media.querySelector('img');
    if (img && !img.complete) {
      img.addEventListener('load', collapse, { once: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupReadMore);
  } else {
    setupReadMore();
  }

  document.addEventListener('shopify:section:load', setupReadMore);
})();